<template>
  <!-- FT-173: страница с закреплённой снизу панелью (v-footer app — кнопки
       мастера договора на телефоне) регистрирует её высоту в
       $vuetify.application.footer. Подвал вне v-main, и отступ v-main его не
       сдвигает — без своего отступа последняя строка подвала уходила под
       панель. На страницах без такой панели вид подвала прежний. -->
  <v-footer padless :class="{ 'pb-16': $vuetify.application.footer > 0 }">
    <v-row justify="center" no-gutters>
      <v-col class="py-4 text-center" cols="12">
        <!-- Тема и язык -->
        <div class="d-flex justify-center align-center flex-wrap mb-2">
          <v-icon @click="changeTheme()" :aria-label="$t('footer.toggle_theme')" class="mx-2 footer-icon">
            mdi-theme-light-dark
          </v-icon>
          <locale-select :class="$vuetify.theme.dark ? 'white--text' : 'black--text'"></locale-select>
        </div>

        <!-- Ссылки -->
        <div class="d-flex justify-center align-center flex-wrap mb-2 footer-links">
          <a 
            :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'}/${$root.$i18n.locale}/agreement`" 
            target="_blank" 
            class="footer-link mx-2 my-1"
            :class="$vuetify.theme.dark ? 'white--text' : 'black--text'"
          >{{ $t('custom.user_agreement') }}</a>
          <span class="d-none d-sm-inline mx-1">|</span>
          <a 
            :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'}/${$root.$i18n.locale}/privacy`" 
            target="_blank" 
            class="footer-link mx-2 my-1"
            :class="$vuetify.theme.dark ? 'white--text' : 'black--text'"
          >{{ $t('custom.privacy_policy') }}</a>
          <span class="d-none d-sm-inline mx-1">|</span>
          <a 
            :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'}/${$root.$i18n.locale}/agreement#refund`" 
            target="_blank" 
            class="footer-link mx-2 my-1"
            :class="$vuetify.theme.dark ? 'white--text' : 'black--text'"
          >{{ $t('custom.refund_policy') }}</a>
          <span class="d-none d-sm-inline mx-1">|</span>
          <a 
            :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'}/${$root.$i18n.locale}/tariffs`" 
            target="_blank" 
            class="footer-link mx-2 my-1"
            :class="$vuetify.theme.dark ? 'white--text' : 'black--text'"
          >{{ $t('custom.pricing') }}</a>
        </div>

        <!-- Копирайт и версия -->
        <div class="d-flex justify-center align-center flex-wrap footer-info">
          <span class="mx-1">{{ new Date().getFullYear() }} — <strong>RentProg</strong></span>
          <span class="d-none d-sm-inline mx-1">|</span>
          <span class="mx-1">{{ checkAppVersion() }}</span>
          <span v-if="$store.getters.getRegion" class="mx-1 text-uppercase font-weight-bold" style="opacity: 0.1; font-size: 12px;">{{ $store.getters.getRegion }}</span>
        </div>
      </v-col>
    </v-row>
    <vue-cookie-accept-decline
      :debug="false"
      :disableDecline="false"
      :showPostponeButton="false"
      @clicked-decline="cookieClickedDecline"
      elementId="cookiePanel"
      position="bottom-left"
      ref="cookiePanel"
      transitionName="slideFromBottom"
      type="floating"
    >
      <!-- Optional -->
      <template #postponeContent>&times;</template>

      <!-- Optional -->
      <template #message>
        <p :class="$vuetify.theme.dark ? 'black--text' : ''">{{ $t('gdrp.text') }}
          <a :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'}/${$root.$i18n.locale}/privacy`" target="_blank">{{ $t('gdrp.more') }}...</a>
        </p>
      </template>

      <!-- Optional -->
      <template #declineContent>{{ $t('gdrp.decline') }}</template>

      <!-- Optional -->
      <template #acceptContent>{{ $t('gdrp.accept') }}</template>
    </vue-cookie-accept-decline>
  </v-footer>
</template>
<script>
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import appVersion from '@/version.js';
import LocaleSelect from '@/components/common/LocaleSelect.vue';
export default {
  components: {
    LocaleSelect,
  },
  methods: {
    cookieClickedDecline() {
      this.$refs.cookiePanel.removeCookie()
    },
    changeTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
    },
    checkAppVersion() {
      // Получаем информацию о текущем приложении
      if (Capacitor.getPlatform() === 'ios' || Capacitor.getPlatform() === 'android') {
        const appInfo = App.getInfo();
        return appInfo.version || appVersion.version;
      } else {
        return appVersion.version || '';
      }
    },
  }
};
</script>
<style scoped>
.footer-icon {
  cursor: pointer;
  font-size: 24px !important;
}

.footer-links {
  font-size: 14px;
  line-height: 1.5;
}

.footer-link {
  text-decoration: none;
  padding: 4px 0;
  display: inline-block;
  min-height: 32px;
  line-height: 24px;
}

.footer-link:hover {
  text-decoration: underline;
}

.footer-info {
  font-size: 13px;
}

/* Мобильные устройства */
@media (max-width: 600px) {
  .footer-links {
    font-size: 13px;
  }
  
  .footer-link {
    margin: 4px 8px !important;
  }
  
  .footer-info {
    font-size: 12px;
  }
}
</style>
